export const Collection = {
  ANNOUNCEMENTS: 'announcements',
  ATTENDEES: 'attendees',
  ATTENDEE_DEVICE: 'attendees-device',
  CHATS: 'chats',
  CONFERENCES: 'conference',
  CONFIGURATIONS: 'configuration',
  EVENT_CARD_STYLES: 'event-card-styles',
  EVENTS: 'events',
  SESSIONS: 'sessions',
  SPEAKERS: 'speakers',
  SPONSORS: 'sponsors',
  TALKS: 'talks',
  VENUES: 'venues',
  MODERATORS: 'moderators',
  VENDORS: 'vendors',
  SPONSORSHIP_LEVELS: 'sponsorship-levels',
  USERS: 'users',
  SUBJECTS: 'subjects',
  POLLS: 'polls',
  QUESTIONS: 'questions',
  ANSWERS: 'poll-answers',
  SETTINGS: 'settings',
  ATTENDANCE: 'attendance',
  BADGE_CONFIGURATIONS: 'badge-configurations',
  BADGE_SUBJECTS: 'badge-subjects'
}

export const Roles = {
  ADMIN: 'admin',
  SUPER_ADMIN: 'super-admin'
}

export const AttendeeRoles = {
  ATTENDEE: 'Attendee',
  SPEAKER: 'Speaker',
  MODERATOR: 'Moderator',
  SPONSOR: 'Sponsor',
  EXHIBITOR: 'Exhibitor'
}

export const AnnouncementStatus = Object.freeze({
  SCHEDULED: 'scheduled',
  SENT: 'sent'
})

export const EventTypes = Object.freeze({
  STANDALONE: 'standalone',
  HAVE_TALKS: 'haveTalks',
  HAVE_SESSIONS: 'haveSessions'
})

export const PollStatus = Object.freeze({
  CREATED: 'created',
  STARTED: 'started',
  PAUSED: 'paused',
  RESUMED: 'resumed',
  CLOSED: 'closed'
})

export const Letters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
]

export const TalkStatus = Object.freeze({
  ASSOCIATED: 'Associated',
  NOT_ASSOCIATED: 'Not Associated'
})

export const SubjectType = Object.freeze({
  ATTENDEE: 'Attendee',
  EXHIBITOR: 'Exhibitor',
  SPEAKER: 'Speaker',
  SPONSOR: 'Sponsor'
})

export const SubjectStatus = Object.freeze({
  INVITE_NOT_SENT: 'Invite not sent',
  AWAITING_RESPONSE: 'Awaiting response',
  PENDING_DATA_REVIEW: 'Pending review',
  APPROVED: 'Approved'
})

export const speakerStatus = Object.freeze({
  PENDING: 'Pending',
  APPROVED: 'Approved'
})

export const SpeakerSubjectFilter = Object.freeze({
  ...SubjectStatus,
  AWAITING_TALKS: 'Awaiting talks'
})

export const attendeeStatusFilter = Object.freeze({
  INVITE_NOT_SENT: 'Invite not sent',
  AWAITING_RESPONSE: 'Awaiting response'
})

export const SubjectTypesList = Object.keys(SubjectType).map((key) => {
  return { id: SubjectType[key], type: SubjectType[key] }
})

export const MeetCSympleTeamEmail = 'hamed.amani@csymplicity.com'

export const SubjectInfoMessages = Object.freeze({
  SPEAKER:
    'We are delighted to extend an invitation to you to join us as a speaker at our upcoming conference?. Your expertise and insights would greatly enrich the event and contribute to its success.',
  EXHIBITOR:
    'We are delighted to extend an invitation to you to join us as an Exhibitor at our upcoming conference?. You will have the opportunity to showcase your products and services to a diverse audience of professionals, researchers, and enthusiasts. Your participation will not only provide valuable exposure for your brand but also contribute to the overall success of the event. Join us to connect with potential clients, build partnerships, and stay at the forefront of industry advancements.',
  SPONSOR:
    'We are delighted to extend an invitation to you to join us as a Sponsor at our upcoming conference?. As a sponsor, you will have the opportunity to showcase your brand, demonstrate your commitment to the industry, and reach a diverse audience of professionals, researchers, and enthusiasts. Your sponsorship will not only support the success of the event but also provide valuable exposure and networking opportunities for your organization.'
})

export const SPONSOR_INFO_TEXT = Object.freeze({
  company: 'Name of your company',
  websiteURL: 'URL of your website',
  bannerClickURL:
    'Enter the destination URL for the banner click. This is the web page or destination where users will be redirected when they click on the banner within the mobile app.',
  introduction:
    "Provide a detailed introduction to your company, highlighting your products, services, and key achievements. This information will be displayed on the sponsor's page in the mobile app, giving event participants a comprehensive understanding of your organization.",
  message:
    'Enter a catchy and concise message about your organization and sponsorship. This message popup in mobile app as participants click your logo displayed with events sponsored by your company, capturing the attention of event participants.',
  logo: 'Upload your company logo here. This logo will be displayed in our mobile app when users view your sponsorship.',
  adBanner:
    'Upload your banner image here. This banner will be displayed in our mobile app on the event details page sponsored by your company.',
  brochure:
    'Upload your sponsor brochure image here. This brochure will be available for users to view when they visit your sponsor introduction page in our mobile app.'
})

export const EXHIBITOR_INFO_TEXT = Object.freeze({
  message:
    'Enter a brief and catchy message that represents your brand and captures the attention of event attendees. This message will be displayed alongside your exhibitor profile in the mobile app, providing a quick overview to attract visitors.',
  introduction:
    'Provide a detailed introduction to your brand, highlighting the unique features, products, or services you offer. This introduction will be displayed on your exhibitor page in the mobile app, giving event attendees a comprehensive understanding of your offerings.',
  logo: 'Upload your company logo here. This logo will be displayed in our mobile app when users view your exhibitor profile, helping to enhance your brand visibility and recognition.'
})

export const SPEAKER_INFO_TEXT = Object.freeze({
  bio: 'Provide a brief biography about yourself. This will be displayed in our mobile app when users view your speaker profile, allowing them to learn more about your background and expertise.',
  profile:
    'Upload your professional headshot here. This photo will be displayed in your speaker profile and alongside the talks you deliver in our mobile app.'
})

export const POLLING_END_USER_MSGS = Object.freeze({
  inActive: {
    header: 'Waiting for poll to Active',
    subText: 'As soon as the poll is active, you will see it on the screen here.'
  },
  toBegin: {
    header: 'Waiting for poll to begin',
    subText:
      'Your poll is underway. As soon as the poll begins, you will see it on the screen here.'
  },
  toResume: {
    header: 'Waiting for poll to resume',
    subText: 'As soon as the poll resumes, you will see it on the screen here.'
  },
  closed: {
    header: 'This poll has been concluded',
    subText: 'We appreciate your participation. Thank you!'
  }
})

export const AssociatedPollMsg =
  'This poll has already been associated with another event, session or talk.'

export const subjectReason = {
  registration: 'registration',
  forApproval: 'for_approval',
  afterApproval: 'after_approval'
}

export const badgeConfigurationDefaultFields = [
  { key: 'FullName', value: 'Full Name' },
  { key: 'Credential', value: 'Credential' },
  { key: 'Position_Title', value: 'Position/Title' },
  { key: 'Organization', value: 'Organization' },
  { key: 'City', value: 'City' },
  { key: 'State', value: 'State' },
  { key: 'Country', value: 'Country' },
  { key: 'Email', value: 'Email' },
  { key: 'Phone', value: 'Phone' }
]

export const possibleBadgeConfigurationFields = [
  { key: 'FullName', value: 'Full Name' },
  { key: 'Credential', value: 'Credential' },
  { key: 'Position_Title', value: 'Position/Title' },
  { key: 'Organization', value: 'Organization' },
  { key: 'City', value: 'City' },
  { key: 'State', value: 'State' },
  { key: 'Country', value: 'Country' }
]

export const badgesSubjectsApplication = ['Attendee', 'Exhibitor', 'Speaker', 'Sponsor']

export const possibleSheetNamesForBadges = ['attendees', 'exhibitors', 'speakers', 'sponsors']
